import { createSlice } from "@reduxjs/toolkit"
import { VOICE_AGENT_ANALYTICS } from "../../../../constants/reducer_names"

const initialState = {
    checked_column: [
        "Agent Name",
        "Inbound Calls",
        "Answered Calls",
        "Abandoned Calls",
        "Missed Calls",
        "Transferred Calls",
        "Talk Time",
        "Average Speed of Answer (ASA)",
        "Avg. Handle Time (AHT)",
        "% Max Handle Time",
        "Total ACW Time",
        "Avg. Hold Time",
        "Occupancy Rate (%)",
        "First Call Resolution (%)",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column2: [
        "Agent Name",
        "Outbound Calls",
        "Answered Calls",
        "Unanswered Calls",
        "Abandoned Calls",
        "Transferred Calls",
        "Talk Time",
        // "Average Speed of Answer (ASA)",
        "Avg. Handle Time (AHT)",
        "% Max Handle Time",
        "ACW Time",
        "Avg. Hold Time",
        "Occupancy Rate (%)",
        "First Call Resolution (%)",
        "Customer Satisfaction (%)",
    ] as any,
    checked_column3: [
        "Agent Name",
        "Callbacks Received",
        "Callbacks Returned",
        "Callbacks Answered",
        "Callbacks Unanswered",
        "Abandoned Callbacks",
        "Callback Duration",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        "Overall Conversion Rate",
        "Callback Success Rate"
    ] as any,
    checked_column4: [
        "Agent Name",
        "Voicemails Received",
        "Voicemails Responded",
        "Voicemails Not Responded",
        "Total Length of Voicemails",
        "Avg. Length of Voicemails"
    ] as any,
    checked_column5: [
        "Agent Name",
        "Call Type",
        "SL1",
        "SL2",
        "SL3",
        "SL4",
        "SL5",
        "SL6",
        "Total",
        "Missed Calls",
        "SLA Achieved (%)",
        "SLA Breached (%)"
    ] as any,
    titleMapper_ForDb: {
        "Agent Name": "agentName",
        "Inbound Calls": "Inboundcalls",
        "Answered Calls": "AnsweredCalls",
        "Abandoned Calls": "abandonedCalls",
        "Missed Calls": "missedCalls",
        "Transferred Calls": "transferredCalls",
        "Talk Time": "Talktime",
        "Average Speed of Answer (ASA)": "avgSpeedofAnswer",
        "Avg. Handle Time (AHT)": "AverageHandleTime",
        "% Max Handle Time": "maximumHandleTime",
        "Total ACW Time": "ACWTime",
        "Avg. Hold Time": "averageHoldTime",
        "Occupancy Rate (%)": "occupancyrate",
        "First Call Resolution (%)": "FirstCallResolution",
        "Customer Satisfaction (%)": "customersatisfaction"
    } as any,
    titleMapper_ForDb2: {
        "Agent Name": "agentName",
        "Outbound Calls": "Outboundcalls",
        "Answered Calls": "AnsweredCalls",
        "Unanswered Calls": "UnAnsweredCalls",
        "Abandoned Calls": "abandonedCalls",
        "Transferred Calls": "transferredCalls",
        "Talk Time": "Talktime",
        // "Average Speed of Answer (ASA)": "avgSpeedofAnswer",
        "Avg. Handle Time (AHT)": "AverageHandleTime",
        "% Max Handle Time": "maximumHandleTime",
        "ACW Time": "ACW",
        "Avg. Hold Time": "averageHoldTime",
        "Occupancy Rate (%)": "occupancyrate",
        "First Call Resolution (%)": "FirstCallResolution",
        "Customer Satisfaction (%)": "customersatisfaction",
    } as any,
    titleMapper_ForDb3: {
        "Agent Name": "agentName",
        "Callbacks Received": "callBackReceived",
        "Callbacks Returned": "callBackReturend",
        "Callbacks Answered": "callBackAnswered",
        "Callbacks Unanswered": "callBackUnanswered",
        "Abandoned Callbacks": "abandonedCall",
        "Callback Duration": "callBackDuration",
        "Avg. Handle Time (AHT)": "avgHandlingTime",
        "Maximum Handle Time": "maxHandlingTime",
        "Overall Conversion Rate": "overallConversationRate",
        "Callback Success Rate": "callbackSuccessRate"
    } as any,
    titleMapper_ForDb4: {
        "Agent Name": "agentName",
        "Voicemails Received": "VoicemailReceived",
        "Voicemails Responded": "VoicemailResponded",
        "Voicemails Not Responded": "VoicemailNotResponded",
        "Total Length of Voicemails": "Total_voicemail_length",
        "Avg. Length of Voicemails": "Avg_voicemail_length",
    } as any,
    titleMapper_ForDb5: {
        "Agent Name": "agentName",
        "Call Type": "CallType",
        "SL1": "SL1",
        "SL2": "SL2",
        "SL3": "SL3",
        "SL4": "SL4",
        "SL5": "SL5",
        "SL6": "SL6",
        "Total": "TotalSLA",
        "Missed Calls": "MissedCalls",
        "SLA Achieved (%)": "SLAAchieved",
        "SLA Breached (%)": "SLAbreached"
    } as any,
    updated_TableColumn: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Inbound Calls',
            dataIndex: 'Inboundcalls',
            key: 'Inboundcalls',
        },
        {
            title: 'Answered Calls',
            dataIndex: 'AnsweredCalls',
            key: 'AnsweredCalls',
        },
        {
            title: 'Abandoned Calls',
            dataIndex: 'abandonedCalls',
            key: 'abandonedCalls',
        },
        {
            title: 'Missed Calls',
            dataIndex: 'missedCalls',
            key: 'missedCalls',
        },
        {
            title: 'Transferred Calls',
            dataIndex: 'transferredCalls',
            key: 'transferredCalls',
        },
        {
            title: 'Talk Time',
            dataIndex: 'Talktime',
            key: 'Talktime',
        },
        {
            title: 'Average Speed of Answer (ASA',
            dataIndex: 'avgSpeedofAnswer',
            key: 'avgSpeedofAnswer',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'AverageHandleTime',
            key: 'AverageHandleTime',
        },
        {
            title: '% Max Handle Time',
            dataIndex: 'maximumHandleTime',
            key: 'maximumHandleTime',
        },
        {
            title: 'Total ACW Time',
            dataIndex: 'ACWTime',
            key: 'ACWTime',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldTime',
            key: 'averageHoldTime',
        },
        {
            title: 'Occupancy Rate (%)',
            dataIndex: 'occupancyrate',
            key: 'occupancyrate',
        },
        {
            title: 'First Call Resolution (%)',
            dataIndex: 'FirstCallResolution',
            key: 'FirstCallResolution',
        },
        // {
        //     title: 'Customer Satisfaction (%)',
        //     dataIndex: 'customersatisfaction',
        //     key: 'customersatisfaction',
        // }
    ] as any,
    updated_TableColumn2: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Outbound Calls',
            dataIndex: 'Outboundcalls',
            key: 'Outboundcalls',
        },
        {
            title: 'Answered Calls',
            dataIndex: 'AnsweredCalls',
            key: 'AnsweredCalls',
        },
        {
            title: 'Unanswered Calls',
            dataIndex: 'UnAnsweredCalls',
            key: 'UnAnsweredCalls',
        },
        {
            title: 'Abandoned Calls',
            dataIndex: 'abandonedCalls',
            key: 'abandonedCalls',
        },
        {
            title: 'Transferred Calls',
            dataIndex: 'transferredCalls',
            key: 'transferredCalls',
        },
        {
            title: 'Talk Time',
            dataIndex: 'Talktime',
            key: 'Talktime',
        },
        // {
        //     title: 'Average Speed of Answer (ASA)',
        //     dataIndex: 'avgSpeedofAnswer',
        //     key: 'avgSpeedofAnswer',
        // },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'AverageHandleTime',
            key: 'AverageHandleTime',
        },
        {
            title: '% Max Handle Time',
            dataIndex: 'maximumHandleTime',
            key: 'maximumHandleTime',
        },
        {
            title: 'ACW Time',
            dataIndex: 'ACW',
            key: 'ACW',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldTime',
            key: 'averageHoldTime',
        },
        {
            title: 'Occupancy Rate (%)',
            dataIndex: 'occupancyrate',
            key: 'occupancyrate',
        },
        {
            title: 'First Call Resolution (%)',
            dataIndex: 'FirstCallResolution',
            key: 'FirstCallResolution',
        },
        // {
        //     title: 'Customer Satisfaction (%)',
        //     dataIndex: 'customersatisfaction',
        //     key: 'customersatisfaction',
        // },

    ] as any,
    updated_TableColumn3: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Callbacks Received',
            dataIndex: 'callBackReceived',
            key: 'callBackReceived',
        },
        {
            title: 'Callbacks Returned',
            dataIndex: 'callBackReturend',
            key: 'callBackReturend',
        },
        {
            title: 'Callbacks Answered',
            dataIndex: 'callBackAnswered',
            key: 'callBackAnswered',
        },
        {
            title: 'Callbacks Unanswered',
            dataIndex: 'callBackUnanswered',
            key: 'callBackUnanswered',
        },
        {
            title: 'Abandoned Callbacks',
            dataIndex: 'abandonedCall',
            key: 'abandonedCall',
        },
        {
            title: 'Callback Duration',
            dataIndex: 'callBackDuration',
            key: 'callBackDuration',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'avgHandlingTime',
            key: 'avgHandlingTime',
        },
        {
            title: 'Maximum Handle Time',
            dataIndex: 'maxHandlingTime',
            key: 'maxHandlingTime',
        },
        {
            title: 'Overall Conversion Rate',
            dataIndex: 'overallConversationRate',
            key: 'overallConversationRate',
        },
        {
            title: 'Callback Success Rate',
            dataIndex: 'callbackSuccessRate',
            key: 'callbackSuccessRate',
        },
    ] as any,
    updated_TableColumn4: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Voicemails Received',
            dataIndex: 'VoicemailReceived',
            key: 'VoicemailReceived',
        },
        {
            title: 'Voicemails Responded',
            dataIndex: 'VoicemailResponded',
            key: 'VoicemailResponded',
        },
        {
            title: 'Voicemails Not Responded',
            dataIndex: 'VoicemailNotResponded',
            key: 'VoicemailNotResponded',
        },
        {
            title: 'Total Length of Voicemails',
            dataIndex: 'Total_voicemail_length',
            key: 'Total_voicemail_length',
        },
        {
            title: 'Avg. Length of Voicemails',
            dataIndex: 'Total_voicemail_length',
            key: 'Total_voicemail_length',
        },
    ] as any,
    updated_TableColumn5: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Call Type',
            dataIndex: 'CallType',
            key: 'CallType',
        },
        {
            title: 'SL1',
            dataIndex: 'SL1',
            key: 'SL1',
        },
        {
            title: 'SL2',
            dataIndex: 'SL2',
            key: 'SL3',
        },
        {
            title: 'SL3',
            dataIndex: 'SL3',
            key: 'SL3',
        },
        {
            title: 'SL4',
            dataIndex: 'SL4',
            key: 'SL4',
        },
        {
            title: 'SL5',
            dataIndex: 'SL5',
            key: 'SL5',
        },
        {
            title: 'SL6',
            dataIndex: 'SL6',
            key: 'SL6',
        },
        {
            title: 'Total',
            dataIndex: 'TotalSLA',
            key: 'TotalSLA',
        },
        {
            title: 'Missed Calls',
            dataIndex: 'MissedCalls',
            key: 'MissedCalls',
        },
        {
            title: 'SLA Achieved (%)',
            dataIndex: 'SLAAchieved',
            key: 'SLAAchieved',
        },
        {
            title: 'SLA Breached (%)',
            dataIndex: 'SLAbreached',
            key: 'SLAbreached',
        },
    ] as any,

}

const agentAnalyticsVoiceSlice = createSlice({
    name: VOICE_AGENT_ANALYTICS,
    initialState,
    reducers: {
        checkedColumn: (state, { payload }) => {
            state.checked_column = payload.checked_column;
        },
        checkedColumn2: (state, { payload }) => {
            state.checked_column2 = payload.checked_column2;
        },
        checkedColumn3: (state, { payload }) => {
            state.checked_column3 = payload.checked_column3;
        },
        checkedColumn4: (state, { payload }) => {
            state.checked_column4 = payload.checked_column4;
        },
        checkedColumn5: (state, { payload }) => {
            state.checked_column5 = payload.checked_column5;
        },
        titleMapperForDb: (state, { payload }) => {
            state.titleMapper_ForDb = payload.titleMapper_ForDb;
        },
        titleMapperForDb2: (state, { payload }) => {
            state.titleMapper_ForDb2 = payload.titleMapper_ForDb2;
        },
        titleMapperForDb3: (state, { payload }) => {
            state.titleMapper_ForDb3 = payload.titleMapper_ForDb3;
        },
        titleMapperForDb4: (state, { payload }) => {
            state.titleMapper_ForDb4 = payload.titleMapper_ForDb4;
        },
        titleMapperForDb5: (state, { payload }) => {
            state.titleMapper_ForDb5 = payload.titleMapper_ForDb5;
        },
        updatedTableColumn: (state, { payload }) => {
            state.updated_TableColumn = payload.updated_TableColumn;
        },
        updatedTableColumn2: (state, { payload }) => {
            state.updated_TableColumn2 = payload.updated_TableColumn2;
        },
        updatedTableColumn3: (state, { payload }) => {
            state.updated_TableColumn3 = payload.updated_TableColumn3;
        },
        updatedTableColumn4: (state, { payload }) => {
            state.updated_TableColumn4 = payload.updated_TableColumn4;
        },
        updatedTableColumn5: (state, { payload }) => {
            state.updated_TableColumn5 = payload.updated_TableColumn5;
        },


    }
})

export const agentAnalyticsVoiceSliceActions = agentAnalyticsVoiceSlice.actions;
export const agentAnalyticsVoiceSliceReducer = agentAnalyticsVoiceSlice.reducer